import React from 'react';
import PropTypes from 'prop-types';

/**
 * ----------------------------------------------------------------------------
 * Modal header component
 * ----------------------------------------------------------------------------
 *
 * @returns
 */
function Header ({ children }) {
  return (
    <div className="app-modal-header">
      {children}
    </div>
  );
}

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default Header;
